import styled from 'styled-components';
import Dropdown from 'monday-ui-react-core/dist/Dropdown';
import { useEffect, useMemo, useState } from 'react';
import { dateFormatOptionsList } from '../../../config/common';

const StyledDropdown = styled(Dropdown)`
  width: 173px;
  z-index: 1000;
`;

const Label = styled.span`
  color: var(--light-primary-text-color, #323338);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const SignDateControllers = ({
  t,
  selectedItem,
  addedFormFields,
  updateFormFields,
}) => {
  const [selectedDateFormat, setSelectedDateFormat] = useState();
  const dateFormatOptions = useMemo(() => dateFormatOptionsList, []);

  function handleDateOptionsChange(value) {
    setSelectedDateFormat(value);
    selectedItem.dateFormat = value;
    updateFormFields([...addedFormFields]);
  }

  useEffect(() => {
    setSelectedDateFormat(
      selectedItem?.dateFormat ? selectedItem.dateFormat : dateFormatOptions[0],
    );
  }, [dateFormatOptions, selectedItem?.dateFormat]);

  return (
    <>
      <Label>{t('Date Format')}</Label>
      <StyledDropdown
        clearable={false}
        value={selectedDateFormat}
        options={dateFormatOptions}
        size={Dropdown.size.SMALL}
        className="dropdown-stories-styles_with-chips"
        onChange={handleDateOptionsChange}
      />
    </>
  );
};

export default SignDateControllers;
